import { LineStyle, LineWidth } from '../renderers/draw-line';
import { LineData } from "../api/data-consumer";

export enum ExtendedType {
	NoExtended = 0,      // default
	ExtendedLeft = 1,    // infinite left side
	ExtendedRight = 2,   // infinite right side
	ExtendedInfinity = 3 // infinite at both sides
}

type LineDataType = LineData;

export interface SimpleLineOptions {
	color: string;
	lineStyle: LineStyle;
	lineWidth: LineWidth;
	extended: ExtendedType;
	data: LineDataType[];
}
